module.exports = __webpack_public_path__ + "static/img/RS4281_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS4281_1.png
// module id = s89g
// module chunks = 0